import { RouterProvider } from 'react-router-dom';
import { BackofficeAuthProvider } from '@/auth/BackofficeAuthProvider';
import { VersionRefreshBanner } from '@/components/shared';
import { router } from '@/routes';

export function App() {
  return (
    <BackofficeAuthProvider>
      <VersionRefreshBanner />
      <RouterProvider router={router} />
    </BackofficeAuthProvider>
  );
}
